import { RowData } from "../../components/Accounts/AccountTransactionTableBody";

export const columnTitle = [
  "Transaction Date",
  "Description",
  "Amount",
  "Payment Type",
  "Transaction ID",
  "Status",
  "    ",
];

export const transactionData: RowData = {
  date: "",
  description: "",
  amount: 0,
  paymentType: "",
  transactionId: "",
  status: "",
  transferFee: "",
  recipientTag: "",
  paymentChannel: "",
};

export const widths: string[] = [
  "22%",
  "18%",
  "14.7%",
  "14%",
  "14.9%",
  "10.9%",
  "7.1%",
];
